module.exports = __webpack_public_path__ + "img/list2.df7781f0.png";